import { Button, Dialog, DialogContent } from '@mui/material'
import React from 'react'

export default function ConfirmDialogPromotion({ open, setOpen, rows, handleAdd }) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการราคาเฉพาะกิจ {/* {{data?.header}} */}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless  ">
                            <thead>
                                <tr>
                                    <th scope="col " class="text-center">ที่</th>
                                    <th scope="col " class="text-center">เมล็ดพันธุ์</th>
                                    <th scope="col " class="text-center">ล็อต</th>

                                    <th scope="col " class="text-center">ราคาปกติ</th>
                                    <th scope="col " class="text-center" style={{ width: '200px' }}>ราคาเฉพาะกิจ </th>

                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.map((lot, i) =>
                                    <tr >
                                        <td class="text-center">{i + 1}</td>
                                        <td class="text-center">{lot?.ItemNo?.CatalogNo?.CatalogName} {lot?.ItemNo?.Option2} {lot?.ItemNo?.Season} {lot?.ItemNo?.Option1} {lot?.ItemNo?.Chemical}</td>
                                        <td class="text-center">{lot?.Lot}</td>

                                        <td class="text-center">{lot?.NormalPrice || lot?.SalePrice}</td>
                                        <td class="text-center">{lot?.PromotionPrice}</td>

                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button onClick={() => handleAdd('Y')} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>

                    </div>
                </div >
            </DialogContent >
        </Dialog >
    )
}
